export default __webpack_public_path__ + "static/media/ESFP.03d3726e.svg";